var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08422 12.2043L1.09271 7.21282C0.792014 6.91213 0.792014 6.40095 1.09271 6.10025L2.1752 5.01776C2.4759 4.71706 2.95701 4.71706 3.2577 5.01776L6.65554 8.38552L13.8722 1.16888C14.1729 0.868186 14.654 0.868186 14.9547 1.16888L16.0372 2.25138C16.3379 2.55207 16.3379 3.06325 16.0372 3.36394L7.19679 12.2043C6.89609 12.505 6.38491 12.505 6.08422 12.2043Z",
    fill: "#079AA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7dd28dd9ac2984f1a0ad32892a1fdd59.svg";
export { ForwardRef as ReactComponent };